import React, { useState, useEffect } from "react";
import bookmarkLockIcon from "../../../../assets/images/bookmark-lock.svg";
import { useSelector, useDispatch } from "react-redux";
import { lockDevice } from "../../AxiosRtk/DeviceDetail";
import { useHistory } from "react-router-dom";
import useLangTranslation from "../../../customHooks/languageProvider";
import useDeviceStatus from "../../../customHooks/deviceStatusProvider";
import CommonStatus from "../Common/CommonStatus";
import { setShowMessage, setErrorInfo } from "../../AxiosRtk/successMessage";
import Select from "react-select";
import KidImage from "../../../shared/KidImage/KidImage";
import { useDashboardDataProvider } from "../../../customHooks/dashboardDataProvider";
import { setRuleDataSetUp } from "../../AxiosRtk/SetRules";
import useFirebase from "../../../../useFirebase";

const LockChildDevice = () => {
  const history = useHistory();
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(false);
  const [deviceStatus, setDeviceStatus] = useState("");
  const { getDeviceStatusData } = useDeviceStatus(deviceStatus, setDeviceStatus);
  const { handleDeviceSelection } = useDashboardDataProvider();
  const { postCollectionData, getCollectionData, createCollectionData } = useFirebase();
  const { setRulesData } = useSelector(({ setRules }) => setRules);
  const [error, setError] = useState("");
  const [time, setTime] = useState({
    from: "",
    to: "",
  });
  const { kidList, selectedKidId, kidDevicesList, selectedDeviceData } =
    useSelector(({ dashboard }) => dashboard);
  const selectedKidData = kidList?.find((item) => item?.ID === selectedKidId);
  const { getLangTranslation } = useLangTranslation();
  const [deviceOptions, setDeviceOptions] = useState([]);

  useEffect(() => {
    if (selectedDeviceData) {
      getCollectionData(selectedDeviceData?.ID);
    }
  }, [selectedDeviceData]);

  useEffect(() => {
    setDeviceOptions(
      kidDevicesList?.map((item) => {
        return { value: item?.ID, label: item?.Name };
      })
    );
  }, [kidDevicesList]);

  useEffect(() => {
    if (setRulesData) {
      setTime({
        from: setRulesData.lockChildDevice.startTime,
        to: setRulesData.lockChildDevice.endTime,
      });
    }
  }, [setRulesData]);

  function callFirebase(payload, showSuccessMessage = false) {
    if (setRulesData) {
      postCollectionData(selectedDeviceData?.ID, payload);
    } else {
      createCollectionData(selectedDeviceData?.ID, payload);
    }
    getCollectionData(selectedDeviceData?.ID);

    if (showSuccessMessage) {
      setTimeout(() => {
        dispatch(
          setShowMessage({
            showMessage: true,
            message: "KEYSTROKE_STATUS_UPDATED",
            defaultMessage: "Changes successfully updated",
          })
        );
      }, 1000);
    } else {
      // Hide the message if not supposed to show
      dispatch(
        setShowMessage({
          showMessage: false,
          message: "",
          defaultMessage: "",
        })
      );
    }
  }

  const handleFormattedTime = () => {
    const status = setRulesData?.lockChildDevice?.lockChildDeviceStatus;
  
    // Define the payload for Firebase
    const lockChildDevice = {
      lockChildDeviceStatus: !status, // Toggle the lock status
      startTime: !status ? time.from : "",
      endTime: !status ? time.to : "",
    };
  
    const payloadFirebase = {
      ...setRulesData,
      lockChildDevice,
    };
  
    // Call Firebase and show success message only when locking the device
    const showSuccessMessage = !status; // true when locking, false when unlocking
    callFirebase(payloadFirebase, showSuccessMessage); // Pass this argument
  };
  

  function handleCancel() {
    setTime({
      hours: { value: 0, error: "" },
      minutes: { value: 0, error: "" },
    });
    setError("");
  }

  const AdminSetRuleLanguageData = useSelector(({ setRules }) => setRules);
  const { appLanguageId } = useSelector(({ misc }) => misc);
  const lang =
    AdminSetRuleLanguageData?.AdminSetRuleLanguageData?.languages?.find(
      (item) => item?.id === appLanguageId
    );
  const [hours, setHours] = useState(0);

  const onChangeHours = (newValue) => {
    setHours(newValue);
  };

  const handleTimeChange = (field, value) => {
    setTime((prevTime) => ({
      ...prevTime,
      [field]: value,
    }));
  };

  const isValidToTime = (value) => {
    const now = new Date();
    const [hours, minutes] = value.split(":").map(Number);
    const selectedTime = new Date();
    selectedTime.setHours(hours, minutes, 0, 0);
    return selectedTime > now;
  };

  // This will check every minute if the current time surpasses the 'to' time
  useEffect(() => {
    const interval = setInterval(() => {
      const currentTime = new Date();
      const [toHours, toMinutes] = time.to.split(":").map(Number);
      const toTime = new Date();
      toTime.setHours(toHours, toMinutes, 0, 0);

      if (currentTime > toTime) {
        const payloadFirebase = {
          ...setRulesData,
          lockChildDevice: {
            lockChildDeviceStatus: false,
            startTime: "",
            endTime: "",
          },
        };

        callFirebase(payloadFirebase);
        clearInterval(interval);
      }
    }, 1000 * 60); // Check every minute

    return () => clearInterval(interval); // Clean up interval
  }, [time.to, setRulesData]);

  return (
    <>
      <div className="card mb-6">
        <div className="card-body">
          <div className="inline-list-wrap separator space-24">
            <div className="list-item">
              <div className="list-content">
                <div
                  className="d-inline-flex align-items-center lh-1 c-pointer"
                  onClick={() => history.goBack()}
                >
                  <i
                    className={`text-blue-900 fs-5 ${
                      lang?.isRTL === 1 ? "icon-arrow-right" : "icon-arrow-left"
                    }`}
                  />
                  <h3 className="text-blue-900 mb-0">
                    {getLangTranslation("CHILD_DETAIL_DEVICE_LOCK", "Lock child device")}
                  </h3>
                </div>
              </div>
            </div>
            <div className="list-item">
              <KidImage imgUrl={selectedKidData?.image} gender={selectedKidData?.gender} />
              <div className="list-content">
                <h5 className="text-blue-900 mb-0">{selectedKidData?.childName}</h5>
                <CommonStatus status={deviceStatus} />
              </div>
            </div>
            <div className="list-item col-12 col-md-3">
              <div className="select-with-icon">
                <span className="icon-wrap icon-blue pt-cursor border-0">
                  <i className="icon-mobile fs-5" />
                </span>
                <Select
                  className="custom-select"
                  classNamePrefix="custom-select"
                  placeholder="Select Device"
                  options={deviceOptions}
                  value={
                    deviceOptions?.find(
                      (item) => item?.value == selectedDeviceData?.ID
                    ) || ""
                  }
                  onChange={handleDeviceSelection}
                  isSearchable={false}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card">
        <div className="card-body">
          {selectedDeviceData ? (
            <>
              <div className="d-flex align-items-center flex-wrap gap-3 mb-6">
                <span className="icon-wrap icon-xl icon-blue icon-rounded border-0 flex-shrink-0">
                  <img src={bookmarkLockIcon} alt="" />
                </span>
                <div>
                  <h5 className="text-blue-900 mb-2">
                    {getLangTranslation(
                      "LOCK_DEVICE_DIALOG_TITLE",
                      "Do you really want to lock this device?"
                    )}
                  </h5>
                  <h6 className="text-dark mb-0">
                    {getLangTranslation(
                      "LOCK_DEVICE_DIALOG_DESCRIPTION",
                      "Please choose the designated time for device lock activation"
                    )}
                  </h6>
                </div>
              </div>
              <div className="d-flex align-items-center gap-3 w-100">
                <div className="">
                  <div className="d-flex gap-3">
                    <span>{getLangTranslation("LOCK_DEVICE_DIALOG_FROM_LABEL", "From")}</span>
                    <div className="form-control-num content-110 w-100">
                      <div className="position-relative">
                        <input
                          type="time"
                          id="from-time"
                          name="from-time"
                          className="form-control text-blue-900 rounded-3 fw-semibold"
                          value={time.from}
                          onChange={(e) => handleTimeChange("from", e.target.value)}
                        />
                      </div>
                    </div>
                    <span>{getLangTranslation("LOCK_DEVICE_DIALOG_TO_LABEL", "To")}</span>
                    <div className="form-control-num content-110 w-100">
                      <div className="position-relative">
                        <input
                          type="time"
                          id="to-time"
                          name="to-time"
                          className="form-control text-blue-900 rounded-3 fw-semibold"
                          value={time.to}
                          onChange={(e) => {
                            const value = e.target.value;
                            if (isValidToTime(value) || value === "") {
                              handleTimeChange("to", value);
                            }
                          }}
                        />
                      </div>
                    </div>
                    <button
                      className="btn btn-primary text-nowrap"
                      onClick={() => handleFormattedTime()}
                    >
                      <span className="btn-upper-case">
                        {!setRulesData?.lockChildDevice?.lockChildDeviceStatus
                          ? getLangTranslation("LOCK_DEVICE_DIALOG_BUTTON_LOCK_DEVICE", "Lock Device")
                          : getLangTranslation("UNLOCK_DEVICE_DIALOG_BUTTON_UNLOCK_DEVICE", "Unlock Device")}
                      </span>
                    </button>
                    <button className="btn btn-outline-primary" onClick={handleCancel}>
                      <span className="btn-upper-case">
                        {getLangTranslation("CANCEL", "Cancel")}
                      </span>
                    </button>
                  </div>
                  {error && (
                    <div>
                      <span className="text-danger" style={{ fontSize: "12px" }}>
                        {getLangTranslation(error)}
                      </span>
                    </div>
                  )}
                </div>
              </div>
            </>
          ) : (
            <div>{getLangTranslation("SELECT_KID_ERR", "Please select device")}</div>
          )}
        </div>
      </div>
    </>
  );
};

export default LockChildDevice;
